import { render, staticRenderFns } from "./CmgIngredientPanel.vue?vue&type=template&id=762f84d6&scoped=true&lang=pug"
import script from "./cmg-ingredient-panel.ts?vue&type=script&lang=ts&external"
export * from "./cmg-ingredient-panel.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgIngredientPanel.vue?vue&type=style&index=0&id=762f84d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "762f84d6",
  null
  
)

export default component.exports